var _path, _path2, _circle, _circle2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMastercard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "section-footer__payment-icon",
    viewBox: "0 0 38 24",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    width: 38,
    height: 24,
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "pi-master"
  }, "Mastercard") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "pi-master"
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.07,
    d: "M35 0H3C1.3 0 0 1.3 0 3v18c0 1.7 1.4 3 3 3h32c1.7 0 3-1.3 3-3V3c0-1.7-1.4-3-3-3z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M35 1c1.1 0 2 .9 2 2v18c0 1.1-.9 2-2 2H3c-1.1 0-2-.9-2-2V3c0-1.1.9-2 2-2h32"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "#EB001B",
    cx: 15,
    cy: 12,
    r: 7
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    fill: "#F79E1B",
    cx: 23,
    cy: 12,
    r: 7
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF5F00",
    d: "M22 12c0-2.4-1.2-4.5-3-5.7-1.8 1.3-3 3.4-3 5.7s1.2 4.5 3 5.7c1.8-1.2 3-3.3 3-5.7z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMastercard);
export default __webpack_public_path__ + "static/media/mastercard.b46794b00b547b3f7cf6574bed2cb56d.svg";
export { ForwardRef as ReactComponent };